import { ReactComponent as CardSample } from 'styles/images/onboarding-card-sample.svg';

import { BottomButton, BottomButtonDefault } from '../Button/BottomButton';
import { Button } from '../Button/Button';

import './onBoarding.css';

//이미지 + 서브버튼 + 하단버튼
export const ImageLinkButton = ({ subBtnText = '확인', onClick, subBtnClick }) => {
  return (
    <div className='onboarding-container'>
      <div className='onboarding-wrap imageLinkButton'>
        <div className='onboarding-content'>
          <div className='img-wrap'>
            <div>
              <CardSample />
            </div>
          </div>
          <div className='link-wrap'>
            <button className='link' onClick={subBtnClick}>
              <span>{subBtnText}</span>
            </button>
          </div>
        </div>
        <div className='onboarding-btn'>
          <BottomButton label='확인' variant='' onClick={onClick} />
        </div>
      </div>
    </div>
  );
};

//아이콘 + 메인텍스트 + 서브텍스트 + 하단 버튼
export const IconTitleDescButton = ({ title, desc, icon, contents, buttons = [], className, titleBottomSlot }) => {
  return (
    <div className='onboarding-container'>
      <div className={`onboarding-wrap iconTitleDescButton ${className || ''}`}>
        <div className='onboarding-content'>
          <div className='icon-wrap'>{icon}</div>

          <div className='title-wrap'>
            <h2>{title}</h2>
            <p>{desc}</p>
          </div>

          {titleBottomSlot}
        </div>

        {contents}

        <div className='onboarding-btn two'>
          {buttons.map((btn, idx) => (
            <BottomButtonDefault key={idx} label={btn.label} variant={btn.variant} onClick={btn.onClick} />
          ))}
        </div>
      </div>
    </div>
  );
};

//메인텍스트 + 서브텍스트 + 이미지 + 하단버튼
export const TitleDescImageButton = () => {
  return (
    <div className='onboarding-container'>
      <div className='onboarding-wrap titleDescImageButton'>
        <div className='onboarding-content'>
          <div className='title-wrap'>
            <h2>내 몸, 1년 동안 잘 지냈을까?</h2>
            <p>데이터를 연동해 나만의 건강도감을 확인해 보세요!</p>
          </div>
          <div className='img-wrap'>
            <div>
              <img src={CardSample} alt='' />
            </div>
          </div>
        </div>

        <div className='onboarding-btn'>
          <BottomButtonDefault label='확인' variant='' />
        </div>
      </div>
    </div>
  );
};

//메인텍스트 + 서브텍스트 + 이미지 + 가이드
export const TitleDescImageMsgBox = () => {
  return (
    <div className='onboarding-container'>
      <div className='onboarding-wrap titleDescImageMsgBox vertical-gap'>
        <div className='onboarding-content '>
          <div className='title-wrap'>
            <h2>데이터를 불러오고 있어요</h2>
            <p>안전하게 수집 중이니 잠시만 기다려주세요!</p>
          </div>
          <div className='img-wrap'>
            <div>
              <img src={CardSample} alt='' />
            </div>
          </div>
          <div className='info-message-box'>
            <div className='info-message-wrap'>
              평균 3일 ~ 7일 소요될 수 있어요. 기다리는 동안 다른 메뉴를 둘러보세요!
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

//메인텍스트 + 서브텍스트 + 이미지
export const TitleDescImage = ({ title, desc, icon, children }) => {
  return (
    <div className='onboarding-container'>
      <div className='onboarding-wrap vertical-gap'>
        <div className='onboarding-content'>
          <div className='title-wrap'>
            <h2>{title}</h2>
            <p>{desc}</p>
          </div>
          <div className='img-wrap'>
            <div>{icon}</div>
          </div>

          {children && <div className='sub-wrap'>{children}</div>}
        </div>
      </div>
    </div>
  );
};

//이미지 + 로더 + 메인텍스트 + 서브텍스트
export const IconLoaderTitleDesc = ({ title, desc, icon, className }) => {
  return (
    <div className={`onboarding-container ${className || ''}`}>
      <div className='onboarding-wrap iconLoaderTitleDesc'>
        <div className='onboarding-content'>
          <div className='icon-wrap'>
            <div className='img-wrap'>
              <div>{icon}</div>
            </div>
          </div>
          <div className='loader-wrap'>
            <div className='loader-st01 blue'></div>
          </div>
          <div className='title-wrap'>
            <h2>{title}</h2>
            <p>{desc}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

//서브타이틀 + 서브타이틀2 + 링크
export const SubTitleDescLink = ({ subtitle, desc, linktext, className, onClick }) => {
  return (
    <div className='onboarding-container'>
      <div className={`onboarding-wrap SubTitleDescLink ${className || ''}`}>
        <div className='onboarding-content'>
          <div className='title-wrap'>
            <h2 className='sub-title'>{subtitle}</h2>
            <p>{desc}</p>
          </div>
          <div className='link-wrap'>
            {/* <Button children={linktext} onClick={onClick} /> */}
            <Button onClick={onClick}>{linktext}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
